// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Description--wrapper--iKGl_","name":"Description--name--2U7Aw"};